<template>
  <div>
    <v-row class="white">
      <v-col class="display-1 ma-3" v-if="!isEdit">REGISTRO DE USUARIOS</v-col>
      <v-col class="display-1 ma-3 text-center" v-else>MODIFICACIÓN</v-col>
    </v-row>
    <v-container class="background-gray text-center">
      <v-row>
        <v-col cols="12" class="pt-0">
          <v-stepper v-model="stepper" class="no-shadow">
            <v-stepper-items>
              <v-stepper-content step="1" class="pa-0 background-gray">
                <v-form ref="formDataUser">
                  <prosic-form-register
                    :isEdit="isEdit"
                    :editEnabled="!editEnabled"
                  ></prosic-form-register>
                </v-form>
                <v-row>
                  <v-divider></v-divider>
                </v-row>
                <v-row v-if="isEdit">
                  <v-col cols="12" lg="6" offset-lg="3">
                    <v-btn
                      v-if="!editEnabled"
                      block
                      color="accent"
                      class="black--text mt-5"
                      @click="editEnabled = true"
                    >
                      Editar permisos
                    </v-btn>
                    <v-btn
                      v-if="!editEnabled"
                      block
                      color="red"
                      class="black--text mt-5 white--text"
                      @click="deleteCurrentUser()"
                    >
                      Eliminar
                    </v-btn>
                    <v-btn
                      v-if="editEnabled"
                      block
                      color="accent"
                      class="black--text mt-5"
                      @click="nextStep(2)"
                    >
                      Siguiente
                    </v-btn>
                  </v-col>
                </v-row>
                <v-btn
                  v-else
                  block
                  color="accent"
                  class="black--text mt-5"
                  @click="nextStep(2)"
                >
                  Siguiente
                </v-btn>
              </v-stepper-content>

              <v-stepper-content step="2" class="pa-0 background-gray">
                <prosic-check-list-register></prosic-check-list-register>
                <v-row>
                  <v-divider></v-divider>
                </v-row>
                <v-btn
                  block
                  color="accent"
                  class="black--text mt-5"
                  @click="nextStep(3)"
                >
                  Siguiente
                </v-btn>
              </v-stepper-content>

              <v-stepper-content step="3" class="pa-0 background-gray">
                <prosic-success-register
                  :isEdit="isEdit"
                ></prosic-success-register>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </v-col>
      </v-row>
    </v-container>
    <v-dialog v-model="openDialog" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2">
          Eliminar usuario
        </v-card-title>

        <v-card-text class="mt-2">
          Estas seguro de eliminar el usuario?
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="openDialog = false">
            Cancelar
          </v-btn>
          <v-btn color="error" @click="confirmDelete">
            Eliminar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import { errorMessage } from "@/services/MessageService";
import FormRegister from "@/components/register/FormRegister";
import CheckListRegister from "@/components/register/CheckListRegister";
import SuccessRegister from "@/components/register/SuccessRegister";
import User from "@/models/user";
import { firestore } from "@/config/firebase";
import { loaderDone, loaderStart } from "@/services/LoaderService";

export default {
  data() {
    return {
      form: User.getRegisterForm(),
      stepper: 1,
      isEdit: false,
      openDialog: false,
      editEnabled: true
    };
  },
  components: {
    ProsicFormRegister: FormRegister,
    ProsicCheckListRegister: CheckListRegister,
    ProsicSuccessRegister: SuccessRegister
  },
  mounted() {
    if (this.id && this.action) {
      this.isEdit = true;
      this.editEnabled = false;
      this.getUserInfo();
    }
  },
  computed: {
    ...mapState("user/register", ["checklist"])
  },
  methods: {
    ...mapActions("user/register", [
      "registerUser",
      "updateUserAccess",
      "deleteUser",
      "resetDataState",
      "updatePersonalInfo"
    ]),
    async getUserInfo() {
      loaderStart();
      try {
        const userSnap = await firestore("users")
          .doc(this.id)
          .get();
        if (userSnap.exists) {
          this.form.name.value = userSnap.data().name;
          this.form.phone.value = userSnap.data().whatsapp;
          this.form.whatsapp.value = userSnap.data().whatsapp;
          this.form.jobPosition.value = userSnap.data().jobPosition;
          this.form.branch.value = userSnap.data().branch;
          const userAccess = userSnap.data().userAccess;
          this.checklist.forEach(typeAccess => {
            typeAccess.value =
              userAccess[typeAccess.id] === undefined
                ? false
                : userAccess[typeAccess.id];
          });
        } else {
          this.$router.push({ name: "usersEdit" });
          errorMessage("El usuario no fue encontrado");
        }
        loaderDone();
      } catch (error) {
        errorMessage("Error al obtener información del usuario");
        loaderDone();
      }
    },
    nextStep(step) {
      if (step === 3) {
        if (this.isEdit) {
          const userData = {
            name: this.form.name.value,
            phoneNumber: this.form.phone.value,
            whatsapp: this.form.whatsapp.value,
            jobPosition: this.form.jobPosition.value,
            password: this.form.passwordEdit.value,
            branch: this.form.branch.value
          };
          this.updatePersonalInfo({ userData, uid: this.id });
          this.updateUserAccess(this.id);
          this.$router.push({ name: "usersEdit" });
        } else {
          const userData = {
            name: this.form.name.value,
            phoneNumber: this.form.phone.value,
            whatsapp: this.form.whatsapp.value,
            jobPosition: this.form.jobPosition.value,
            email: this.form.email.value,
            branch: this.form.branch.value,
            password: this.form.password.value
          };
          this.registerUser(userData);
          this.$router.push({ name: "usersEdit" });
        }
        this.resetData();
      } else {
        if (this.stepper == 1) {
          if (this.$refs.formDataUser.validate()) {
            if (this.form.verifyPassword.value != this.form.password.value) {
              errorMessage("Las contraseñas no coinciden");
            } else {
              this.stepper = step;
            }
          }
        } else {
          this.stepper = step;
        }
      }
    },
    resetData() {
      this.form.name.value = "";
      this.form.phone.value = "";
      this.form.whatsapp.value = "";
      this.form.jobPosition.value = "";
      this.form.branch.value = "";
      this.form.email.value = "";
      this.form.password.value = "";
      this.form.verifyPassword.value = "";
      this.form.verifyPasswordEdit.value = "";
      this.form.passwordEdit.value = "";
      this.stepper = 1;
      this.isEdit = false;
      this.openDialog = false;
      this.editEnabled = true;
    },
    async deleteCurrentUser() {
      if (this.id) {
        this.openDialog = true;
      }
    },
    async confirmDelete() {
      if (this.id) {
        this.openDialog = false;
        await this.deleteUser(this.id);
        this.$router.push({ name: "usersEdit" });
      }
    }
  },
  beforeDestroy() {
    this.resetData();
    this.resetDataState();
  },
  props: {
    id: {
      type: String
    },
    action: {
      type: String
    }
  }
};
</script>
<style>
.background-gray {
  background: #f6f6f6 !important;
}
.full-width-content {
  width: -webkit-fill-available !important;
}
.divider-field {
  width: 30px !important;
}
.no-shadow {
  box-shadow: none !important;
  -webkit-box-shadow: none !important;
}
</style>
